<div class="mb-3">
  @if (control().hasLabel) {
    <mat-label [style.color]="control().labelColour">{{ control().label }}</mat-label>
  }
  <mat-list class="mat-list-dynamic">
    @for (item of control().billingIcd10ListValue; track item.code; let i = $index) {
      <mat-list-item [style.color]="control().valueColour">
        @if (control().displayCodeDetails) {
          <span>{{ item.code }} - {{ item.description }}</span>
        } @else {
          <span>{{ item.code }}</span>
        }
      </mat-list-item>
    }
  </mat-list>
</div>
